
import {  gsap } from "gsap";
import { GameMode } from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import { RoadRage } from "../../RoadRage";
import { IAllWinData, IBetWayWinData } from "../../server/data/IData";
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { RoadRageEngineController } from "../../reel/RoadRageEngineController";
import { NoWinPosterState, PosterManager } from '../../independent/poster/PosterManager';
import { Helper } from "../../../dev/utils/Helper";
import { RoadRageSpriteSymbol } from "../../reel/symbol/RoadRageSpriteSymbol";
import { MiniPayTable } from "../../../dev/extra/MiniPayTable";
import { GameSetting } from "../../../dev/setting/GameSetting";
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { GameData, InitData, BaseModel } from '../../server/data/BaseModel';
import { Presentation, PresentationState } from "../../../dev/gameflow/controller/Presentation";
import { RoadRageReelOverlay } from '../../reel/RoadRageReelOverlay';
import { ScatterSymState } from "../../reel/symbol/RoadRageScatterLamps";
import { SoundManager } from '../../config/sound/SoundManager';

export class NormalIdlePresentation extends Presentation {

    private _gameData: GameData;
    private _allHits: IAllWinData;

    private static _idleTimeline: gsap.core.Timeline | null;

    private _normalStart: boolean = false;
    private triggerIntroAnim: boolean = true;
    private static idleActivated: boolean = false;

    private _noWinCounter: number = 0;

    private firstTimeIntro: boolean = true;
    private playFirstTimeIntro: boolean = false;
    
    private static _soundIndx: number = 0;
    private static _badWins: number = 0;

    private static _noPosters: string[] = [
        NoWinPosterState.FLAT_TIRE,
        NoWinPosterState.EXPIRED,
        NoWinPosterState.LOW_GAS
    ];

    private static nextNoWinPoster: Generator<string, string, string> = NormalIdlePresentation.getNextNoPoster();
    private static *getNextNoPoster(): Generator<string, string, string> {
        let i: number = 0;
        while (true) {
            yield this._noPosters[i % this._noPosters.length]
            i++;
        }
    }

    public checkForActivation(data: GameData): boolean { return data.nextMode == GameMode.NORMAL; }

    public setInitData(data: InitData): void {
        if (data.mode == GameMode.NORMAL && data.nextMode == GameMode.NORMAL) {
            this._normalStart = true;
            this.PresentationState.set(PresentationState.ACTIVATED);
        }
        if (GameSetting.replayMode) this.triggerIntroAnim = false;
    }

    public setGamedData(data: GameData) {

        this._gameData = data;

        this._allHits = data.Win.allBetWayWinData;

        if (data.Win.isBigWin || this._gameData.lastFSRound) this._noWinCounter = 0;

        if (this._gameData.lastFSRound) this.triggerIntroAnim = false;

        NormalIdlePresentation._badWins += data.Win.winRatio < 1 ? 1 : 0;

        this.playFirstTimeIntro = this.firstTimeIntro && data.isNormalMode && data.nextMode === GameMode.NORMAL
        this.firstTimeIntro = false;

        if(data.Win.winRatio > 3){
            NormalIdlePresentation._soundIndx = 1;            
            NormalIdlePresentation._badWins = 0;
        }else{
            if(NormalIdlePresentation._badWins > 5) {
                NormalIdlePresentation._soundIndx = -1;
                NormalIdlePresentation._badWins = 0;
            }else{
                NormalIdlePresentation._soundIndx = 0;
            }
        }
    }

    public preStart(): void {
        if (this._gameData && this._gameData.Win.singleWin == 0) this._noWinCounter++;
        else this._noWinCounter = Math.max(0, this._noWinCounter - 2)

        NormalIdlePresentation.idleActivated = true;
        BaseModel.buyFeatureName = "";
        SoundManager.onIdle();
    }

    public createPresentation(): void {
        
        // RoadRageReelOverlay.instance.playLightning(true);
        // if(!RoadRageEngineManager.wantsToSwitch)
        //     RoadRage.overlayAnim.onIdle(true);

        if(this.playFirstTimeIntro){
            this.playFirstTimeIntro = false;
            this.timeline.add(RoadRage.reelManager.playFirstIntro());
        }else{
            SoundManager.StartMainMusic(true)
            PosterManager.instance.hideSign();

            RoadRageReelOverlay.instance.setDisabled(false, [0, 1, 2, 3, 4]);

            if (!SlotGame.autoPlayPlugin.isAutoplayRound) {
                RoadRageEngineManager.RAll((rc: RoadRageEngineController) => {
                    rc.applySymbolInteraction(true);
                })
            };
    
            RoadRageEngineManager.RSWindow((rc: RoadRageEngineController,sym:RoadRageSpriteSymbol) => {
                sym.scatterState({state:ScatterSymState.IDLE})
            });
    
            if (this._noWinCounter >= 15) this._noWinCounter = 0;
    
            if(!this._gameData.Win.isIndiviWinBelowStake()){
                if (this._allHits && this._allHits.longest > 0) {
                    NormalIdlePresentation._idleTimeline = Helper.setTimeline(NormalIdlePresentation._idleTimeline!, undefined, false);
                    NormalIdlePresentation._idleTimeline.add(() => this.addWinCountUpToTimeline(), 0.5);
                }
            }
        }

        this.PresentationState.setInactive();
    }

    public static DisableNormalIdle(ignoreSizeChange: boolean = false): void {

        if (this.idleActivated) {
            this._idleTimeline = Helper.setTimeline(this._idleTimeline!, undefined, false);
            RoadRage.counter.stop(undefined, undefined, 0, true).add(() => RoadRageEngineManager.RSAll((rc, sym) => {
                sym.stopWin(0.2)
            }), 0)

            MiniPayTable.instance.stop();

            RoadRageEngineManager.RSWindow((rc: RoadRageEngineController) => {
                rc.applySymbolInteraction(false);
            })

            RoadRage.bgOverlay.allBoxes.forEach(b => b.enable(false,true));
            if (!ignoreSizeChange) RoadRageEngineManager.preferedLayoutSize = 3;
            
            this.idleActivated = false;
            
            SoundManager.onBet(this._soundIndx)
        }
    }

    protected addWinCountUpToTimeline(): void {

        NormalIdlePresentation._idleTimeline = new gsap.core.Timeline({
            repeat: -1,
            repeatDelay: 0,
        });

        const delay: number = 3;
        const duration: number = 1.2;
        NormalIdlePresentation._idleTimeline.to(this, { duration: delay });
        NormalIdlePresentation._idleTimeline.add(() => {RoadRage.counter.alpha = 1}, delay)

        const winGrps: IBetWayWinData[] = this._gameData.Win.betWayWins!;

        // Start Wins
        for (let groups = 0; groups < winGrps.length; groups++) {
            const winData: IBetWayWinData = winGrps[groups];
            for (let reel = 0; reel < winData.reelWinPositions.length; reel++) {
                let posRow: boolean[] = winData.reelWinPositions[reel];
                for (let row = 0; row < posRow.length; row++) {
                    const sym: RoadRageSpriteSymbol | undefined = RoadRageEngineManager.getReel(reel).getSymbol(row);
                    const hits: boolean = posRow[row];
                    if (sym) {
                        NormalIdlePresentation._idleTimeline.add(() => {
                            if (hits) sym.PlayIdle(duration);
                            sym.markNonWin(!hits)!;
                        }, delay + (groups * duration))
                    }
                }
            }
            NormalIdlePresentation._idleTimeline.add(() => RoadRage.counter.setValue(winData.amount, winData.numberOfCombinations), delay + (groups * duration))
        }

        if (winGrps.length > 1) {
            for (let reel = 0; reel < this._allHits.reelWinPositions.length; reel++) {
                for (let row = 0; row < this._allHits.reelWinPositions[reel].length; row++) {
                    const sym: RoadRageSpriteSymbol | undefined = RoadRageEngineManager.getReel(reel).getSymbol(row);
                    const hits: boolean = this._allHits.reelWinPositions[reel][row];
                    if (sym) {
                        NormalIdlePresentation._idleTimeline.add(() => {
                            if (hits) sym.PlayIdle(duration,);
                            sym.markNonWin(!hits)!;
                        }, delay + (winGrps.length * duration))
                    }
                }
            }
        }

        NormalIdlePresentation._idleTimeline.add([
            () => RoadRage.counter.setValue(this._gameData.Win.singleWin, this._allHits.totalWinCombination),
            () => RoadRage.counter.stop(undefined, duration / 2, duration, true),
        ], delay + (winGrps.length == 1 ? 0 : (winGrps.length * duration)));

        NormalIdlePresentation._idleTimeline.to(this, { duration: duration });

        NormalIdlePresentation._idleTimeline.add(() => RoadRageEngineManager.RSAll((rc, s) => s.markNonWin(false, undefined, duration / 2)));

        NormalIdlePresentation._idleTimeline.to(this, { duration: duration / 2 });
        NormalIdlePresentation._idleTimeline.play();
    }

    skip(): void {
        if (!this.PresentationState.equal(PresentationState.INACTIVE))
            super.skip();
    }

    public done(): void {

        // RoadRage.bgOverlay.fsDummyBox.onResize();
    }
}